import React, { FC, ReactElement, }  from "react";
import { Button, classNames, FormControlSize, getFormSizeSuffix, } from ".";
import { TimesIcon } from "./Icons";

interface Props {
    value: string | number;
    name?: string;
    className?: string | string[];
    readonly?: boolean;
    disabled?: boolean;
    placeholder?: string;
    focused?: boolean;

    size?: FormControlSize;

    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onClear?: () => void;
}

export const TextInput: FC<Props> = (props): ReactElement => {
    const {
        value,
        name,
        className,
        readonly,
        disabled,
        onChange,
        placeholder,
        focused,
        size,
        onClear,
        onKeyPress,
    } = props;

    const inputSize = size === FormControlSize.Small || size === FormControlSize.Large ? size : null;

    const css = classNames([
        "form-control",
        inputSize && `form-control-${getFormSizeSuffix(inputSize)}`,
        className ? (Array.isArray(className) ? classNames([...className]) : className) : null,
        readonly ? "readonly" : null,
        disabled ? "disabled" : null,
        "__textbox__",
    ]);

    const valueProps = onChange ? {
        value: value === undefined ? "" : value,
        onChange,
    } : {
        defaultValue: value === undefined ? "" : value,
    };

    const input = (
        <input
            type="text"
            name={name}
            className={css}
            readOnly={readonly}
            disabled={disabled}
            autoFocus={focused}
            placeholder={placeholder}
            onKeyPress={onKeyPress}
            autoComplete="off"
            {...valueProps}
        />
    );

    // wrap everything in an input group if we're also rendering the clear button
    if (onClear) {
        const groupCss = classNames([
            "input-group",
            readonly ? "readonly" : null,
            disabled ? "disabled" : null,
            "__textinputgroup__"
        ]);

        return (
            <div className={groupCss}>
                {input}

                <Button
                    label={"Clear value"}
                    size={size}
                    onClick={onClear}
                >
                    {TimesIcon}
                </Button>
            </div>
        );
    }

    return input;
}
